export const iconFontAwesomeMedicalHealthLungsVirus = (
	<i className="fa-solid fa-lungs-virus"></i>
);
